import { Link } from "react-router-dom";
import { Column } from "@/components/Datatable/types";
import { SessionsReportItem } from "../../api/fetchSessionsReport/types";

export function sessionsReportColumns(): Column<SessionsReportItem>[] {
  return [
    {
      header: "Event",
      accessorKey: "eventName",
      enableSorting: true,
      cell: ({ row }) => row.original.eventName,
    },
    {
      header: "Session",
      accessorKey: "sessionName",
      enableSorting: true,
      cell: ({ row }) => row.original.sessionName,
    },
    {
      header: "Start Date",
      accessorKey: "startDate",
      enableSorting: true,
      cell: ({ row }) => row.original.startDate ?? "",
    },
    {
      header: "End Date",
      accessorKey: "endDate",
      enableSorting: true,
      cell: ({ row }) => row.original.endDate ?? "",
    },
    {
      header: "Location",
      accessorKey: "location",
      enableSorting: true,
      cell: ({ row }) => row.original.location,
    },
    {
      header: "Capacity",
      accessorKey: "capacity",
      enableSorting: true,
      cell: ({ row }) => row.original.capacity,
    },
    {
      header: "Enrolled",
      accessorKey: "enrolled",
      enableSorting: true,
      cell: ({ row }) => row.original.enrolled,
    },
    {
      header: "Status",
      accessorKey: "status",
      enableSorting: true,
      cell: ({ row }) => row.original.status,
    },
    {
      header: "Roster",
      accessorKey: "sessionId",
      cell: ({ row }) => {
        if (row.original.sessionId == null) {
          return "";
        }
        const label = [row.original.eventName, row.original.sessionName]
          .filter(Boolean)
          .join(" - ");
        const params = new URLSearchParams({
          sessionIds: String(row.original.sessionId),
        });
        if (label) {
          params.set("sessionLabel", label);
        }
        return (
          <Link
            className="text-blue-600 hover:underline"
            to={`/admin/events/reports/roster-management?${params.toString()}`}
          >
            View Roster
          </Link>
        );
      },
    },
  ];
}
